import request from '../config/axiosConfig';
import { GET_LIST_QUIZZES, GET_QUIZ_INFO, CREATE_QUIZ, UPDATE_QUIZ, DELETE_QUIZ, UPDATE_QUIZ_QUESTIONS } from '../constants/quizApiEndPoint';

export const getQuizzes = async (params) => {
  return (
    await request({
      url: GET_LIST_QUIZZES,
      method: 'GET',
      params,
    })
  )?.data;
};

export const getQuizInfo = async (id) => {
  return (
    await request({
      url: GET_QUIZ_INFO,
      method: 'GET',
      params: { id },
    })
  )?.data;
};

export const createQuiz = async (data) => {
  return (
    await request({
      url: CREATE_QUIZ,
      method: 'POST',
      data,
    })
  )?.data;
};

export const updateQuiz = async (id, data) => {
  return (
    await request({
      url: UPDATE_QUIZ,
      method: 'POST',
      params: { id },
      data,
    })
  )?.data;
};

export const deleteQuiz = async (id) => {
  return (
    await request({
      url: DELETE_QUIZ,
      method: 'DELETE',
      params: { id },
    })
  )?.data;
};
export const updateQuizQuestions = async ({ id, question_ids }) => {
  return (
    await request({
      url: UPDATE_QUIZ_QUESTIONS,
      method: 'POST',
      params: { id },
      data: { question_ids },
    })
  )?.data;
};
